import type { Theme } from '@simplywallst/ui-core';

import type { BriefColorVariants } from './types';

export function getColor(fill: BriefColorVariants, theme: Theme) {
  switch (fill) {
    case 'good':
      return theme.color.good;
    case 'bad':
      return theme.color.bad;
    case 'neutral':
      return theme.color.whiteRGBA(0.5);
    case 'warning':
      return theme.color.warning;
    case 'default':
    default:
      return theme.color.mediumGray;
  }
}
